import { useState } from "react";
import MessageDialogWithActions from "components/MessageDialogWithActions";
import { ButtonSecondary } from "components/Buttons";
import { DesktopComputerIcon } from "@heroicons/react/outline";
import { isDev } from "lib/useful";
import { certPOSTj } from "lib/API";
import { store } from "react-recollect";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

function DigiPremPhotoCroppingDialog({ handleClose, fulfilment }) {
  // const digiPremPhotoSize = { w: 148, h: 105 }; // a6
  // const digiPremPhotoSize = { w: 105, h: 74 }; // a7 (print in the middle of an a6)
  // const digiPremPhotoSize = { w: 190.7, h: 80 }; // full cert width
  const digiPremPhotoSize = { w: 180.7, h: 70, aspect: 180.7 / 70 }; // Emily-requested 5mm border

  const [cropData, setCropData] = useState(() =>
    JSON.parse(JSON.stringify(fulfilment.cropData ?? {})),
  );
  const [aspect, setAspect] = useState(digiPremPhotoSize.aspect);
  const handleToggleAspect = () =>
    setAspect((a) => (a ? null : digiPremPhotoSize.aspect));

  function handleCropChange(pixels, percent) {
    setCropData((cd) => ({ ...cd, pixels, percent }));
  }

  const photoBase = isDev() ? "http://localhost:4040/" : "/";
  const origPhoto = `${photoBase}api/cropPremOriginal/${fulfilment._id}.png?token=${store.token}`;

  function imageLoaded(e) {
    const { scrollWidth, scrollHeight, naturalWidth, naturalHeight } = e.target;
    setCropData((cd) => ({
      ...cd,
      scrollWidth,
      scrollHeight,
      naturalWidth,
      naturalHeight,
    }));
  }

  async function save() {
    console.log(cropData);
    const r = await certPOSTj("fulfilmentUpdate", {
      ...fulfilment,
      cropData,
    });
    store[`fulfilments-digipremcert`][r.data._id] = r.data;
    handleClose();
  }

  return (
    <MessageDialogWithActions
      wide
      tall
      name="DigiPremPhotoCroppingDialog"
      message={
        <div className="m-2 border-4 border-black overflow-x-hidden bg-slate-200">
          <ReactCrop
            crop={cropData?.pixels}
            onChange={handleCropChange}
            onComplete={handleCropChange}
            aspect={aspect}
            ruleOfThirds
          >
            <img
              src={origPhoto}
              id="croppingImage"
              onLoad={imageLoaded}
              alt=""
            />
          </ReactCrop>
        </div>
      }
      actionLineAdditionalContent={
        <ButtonSecondary onClick={handleToggleAspect}>
          {aspect ? "Aspect OFF" : "Restrict to aspect"}
        </ButtonSecondary>
      }
      actions={[
        {
          text: "Cancel",
          colour: "red",
          onClick: handleClose,
        },
        {
          text: "Save",
          colour: "green",
          onClick: save,
        },
      ]}
    />
  );
}

function DigiPremPhotoCroppingDialogButton({ fulfilment, onClose }) {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };
  return (
    <>
      {open && (
        <DigiPremPhotoCroppingDialog
          fulfilment={fulfilment}
          handleClose={handleClose}
        />
      )}
      <ButtonSecondary onClick={() => setOpen(true)}>
        <DesktopComputerIcon className="size-6 inline-block" />
        &nbsp;Crop&hellip;
      </ButtonSecondary>
    </>
  );
}

export default DigiPremPhotoCroppingDialogButton;
